import {
  Box,
  Card,
  Checkbox,
  Dialog,
  FormControl,
  InputLabel,
  MenuItem,
  Chip,
  Button as MUIButton,
  Select,
  Tooltip,
  Typography,
} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import dayjs from 'dayjs';
import { ReactElement, Fragment, useState } from 'react';
import {
  BulkDeleteButton,
  CreateButton,
  Datagrid,
  EditButton,
  Filter,
  FunctionField,
  List,
  TextField,
  NumberField,
  TopToolbar,
  useListController,
  useTranslate,
  DeleteButton,
  SelectField,
  TextInput,
  SelectInput,
  FilterForm,
} from 'react-admin';
import { CustomBreadcrumbs } from '../../../../components/custom-breadcrumbs';
import FilterGroup from 'src/pages/admin/components/FilterGroup';
import { DashboardContent } from '../../../../layouts/dashboard';
import { Resources } from '../resource';
import { PermissionGuard } from 'src/routes/components/permission-guard';
import ErrorPage403 from 'src/pages/error/403';
import { PermissionButton } from 'src/routes/components/permission-button';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import StarsOutlinedIcon from '@mui/icons-material/StarsOutlined';
import UpgradeIcon from '@mui/icons-material/Upgrade';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import CreateAgent from './Create';
import EditAgentInfo from './Edit';
import UpgradeAgentLevel from './Upgrade';
import SetUnlimitedLevel from './SetUnlimited';
import AgentInfoDetails from './Details';
import CreateReferral from './CreateReferral';
import { SplashScreen } from 'src/components/loading-screen';

const ListFilter = (props: any) => {
  const { filterValues, isLoading } = useListController();
  // console.log('=== filterValues ===', filterValues);
  return (
    // 外层容器：控制SplashScreen覆盖整个过滤组件区域
    <div style={{ position: 'relative' }}>
      {/* 1. 原有过滤组件 */}
      <Filter {...(props || {})}>
        <FilterGroup alwaysOn spacing={0} p={0}>
          <FilterGroup>
            <TextInput source="userId" label="module.agentInfo.userId" />
            <TextInput source="walletAddress" label="module.agentInfo.walletAddress" />
            {/*<TextInput source="email" label="module.agentInfo.email" />*/}
            <TextInput source="invitationCode" label="module.agentInfo.invitationCode" />
          </FilterGroup>
        </FilterGroup>
      </Filter>

      {/* 2. SplashScreen：加载中显示，加载完自动关闭 */}
      {/* 关键：position:absolute 让加载框覆盖整个过滤区域 */}
      {isLoading && (
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'rgba(255,255,255,0.8)', // 半透明背景，避免遮挡感知
          zIndex: 10 // 确保在过滤组件之上
        }}>
          <SplashScreen />
        </div>
      )}
    </div>
  );
};
// const FilterFormInput = (props: any) => {
//    return   <FilterForm {...(props || {})}>
//         <TextInput source="userId"        label="module.agentInfo.userId"        alwaysOn />
//         <TextInput source="walletAddress" label="module.agentInfo.walletAddress"  alwaysOn />
//         <TextInput source="email"         label="module.agentInfo.email"         alwaysOn />
//       </FilterForm>
// }

const AgentInfoList = () => {
  const [popup, setPopup] = useState<ReactElement>();
  const translate = useTranslate();

  const ActionButton: React.FC<React.ComponentProps<typeof MUIButton>> = (props) => (
    <MUIButton
      variant="text"
      size="small"
      color="primary"
      sx={{
        textTransform: 'none',
        fontWeight: 600,
        px: 0,
        minWidth: 0,
        '& .MuiButton-startIcon': { ml: 0 },
      }}
      {...props}
    />
  );

  return (
    <DashboardContent>
      <PermissionGuard resource="agent-info" action="read" fallback={<ErrorPage403 />}>
        <CustomBreadcrumbs
          heading={translate('resource.agentInfo')}
          links={[
            {
              name: translate('resource.agentInfo'),
              href: `/${Resources.agentInfo}`,
            },
            { name: translate('resource.list') },
          ]}
          // action={
          //   <PermissionGuard resource="agent-info" action="create" fallback={<></>}>
          //     <CreateButton
          //       variant="contained"
          //       size="medium"
          //       onClick={(e) => {
          //         e.preventDefault();
          //         setPopup(<CreateAgent onClose={() => setPopup(undefined)} />);
          //       }}
          //     />
          //   </PermissionGuard>
          // }
        />

        <Card sx={{ mt: 3, pb: 2 }}>
          <List
            actions={false}
            empty={false}
            perPage={10}
            exporter={false}
            filters={<ListFilter />}
          >
            {/* <FilterFormInput /> */}
            <Box sx={{ overflow: 'auto' }}>
              <Datagrid
                rowClick={false}
                bulkActionButtons={
                  <PermissionButton resource="agent-info" action="delete">
                    <BulkDeleteButton />
                  </PermissionButton>
                }
                sx={{
                  '& .RaDatagrid-tableWrapper': { overflowX: 'auto' },
                  '& .RaDatagrid-table': { tableLayout: 'auto' },
                  '& .column-userId': {
                    whiteSpace: 'nowrap',
                    minWidth: 320,
                  },
                  '& .column-userLevel': {
                    whiteSpace: 'nowrap',
                    minWidth: 90,
                    textAlign: 'center',
                  },
                  '& .col-isInfiniteAgent': {
                    whiteSpace: 'nowrap',
                    minWidth: 120,
                    textAlign: 'center',
                  },
                  '& .column-walletAddresses': {
                    whiteSpace: 'normal',
                    overflow: 'visible',
                    minWidth: 440,
                    textOverflow: 'unset',
                  },
                  '.RaBulkActionsToolbar-toolbar': {
                    position: 'relative !important',
                    transform: 'none !important',
                  },
                }}
              >
                <TextField source="userId" label="module.agentInfo.userId" sortable={false} />
                {/* <TextField source="user.email" label="module.agentInfo.email" sortable={false} /> */}
                {/*<TextField source="userLevel" label="module.agentInfo.userLevel" sortable={false} defaultValue={record}/>*/}
                <FunctionField
                  source="userLevel"
                  label="module.agentInfo.userLevel"
                  cellClassName="column-userLevel"
                  headerClassName="column-userLevel"
                  sortable={false}
                  render={(record) => {
                    // 安全获取 user.agentLevelId，防止数据不存在时报错
                    const agentLevelId = record?.user?.agentLevelId ?? '-';
                    return <span>{agentLevelId}</span>;
                  }}
                />
                {/* <TextField
                  source="walletAddresses"
                  label="module.agentInfo.walletAddresses"
                  sortable={false}
                /> */}

                <FunctionField
                  source="walletAddresses"
                  label="Wallet Addresses"
                  render={({ walletAddresses = [] }: any) => (
                    <span style={{ whiteSpace: 'normal' }}>
                      {walletAddresses.map((a: string, i: number) => (
                        <Fragment key={i}>
                          <span style={{ whiteSpace: 'nowrap' }}>{a}</span>
                          {i < walletAddresses.length - 1 ? ', ' : null}
                          <wbr />
                        </Fragment>
                      ))}
                    </span>
                  )}
                />

                <FunctionField
                  label="module.agentInfo.isInfiniteAgent"
                  cellClassName="col-isInfiniteAgent"
                  headerClassName="col-isInfiniteAgent"
                  render={(record) => (
                    <Chip
                      label={record.isInfiniteAgent ? 'True' : 'False'}
                      color={record.isInfiniteAgent ? 'success' : 'error'}
                      size="small"
                    />
                  )}
                  sortable={false}
                />

                <FunctionField
                  render={(record: any) => (
                    <Stack direction="row" spacing={2}>
                      {/* Details */}
                      <ActionButton
                        startIcon={<InfoOutlinedIcon />}
                        onClick={(e) => {
                          e.preventDefault();
                          setPopup(
                            <AgentInfoDetails
                              row={record}
                              open
                              onClose={() => setPopup(undefined)}
                            />
                          );
                        }}
                      >
                        Details
                      </ActionButton>

                      {/* Set To Unlimited */}
                      {!record?.isInfiniteAgent && (
                        <PermissionGuard resource="agent-info" action="set" fallback={<></>}>
                          <ActionButton
                            startIcon={<StarsOutlinedIcon />}
                            onClick={(e) => {
                              e.preventDefault();
                              setPopup(
                                <SetUnlimitedLevel
                                  row={record}
                                  onClose={() => setPopup(undefined)}
                                />
                              );
                            }}
                          >
                            Set
                          </ActionButton>
                        </PermissionGuard>
                      )}

                      {/* Upgrade Level */}
                      {!record?.isInfiniteAgent && (
                        <PermissionGuard
                          anyOf={[
                            { resource: 'agent-info', action: 'upgrade' },
                            { resource: 'agent-info', action: 'upgrade-plus' },
                          ]}
                          fallback={<></>}
                        >
                          <ActionButton
                            startIcon={<UpgradeIcon />}
                            onClick={(e) => {
                              e.preventDefault();
                              setPopup(
                                <UpgradeAgentLevel
                                  row={record}
                                  onClose={() => setPopup(undefined)}
                                />
                              );
                            }}
                          >
                            Upgrade
                          </ActionButton>
                        </PermissionGuard>
                      )}

                      {/* <PermissionGuard resource="agent-info" action="update" fallback={<></>}>
                        <EditButton
                          onClick={(e) => {
                            e.preventDefault();
                            setPopup(
                              <EditAgentInfo
                                id={record.userId}
                                onClose={() => setPopup(undefined)}
                              />
                            );
                          }}
                        />
                      </PermissionGuard> */}
                      {/* <PermissionGuard resource="agent-info" action="delete" fallback={<></>}>
                        <DeleteButton mutationMode="pessimistic" />
                      </PermissionGuard> */}

                      {
                        <PermissionGuard
                          anyOf={[{ resource: 'agent-info', action: 'create-referral' }]}
                          fallback={<></>}
                        >
                          <ActionButton
                            startIcon={<AddCircleOutlineIcon />}
                            onClick={(e) => {
                              e.preventDefault();
                              setPopup(
                                <CreateReferral row={record} onClose={() => setPopup(undefined)} />
                              );
                            }}
                          >
                            SetReferral
                          </ActionButton>
                        </PermissionGuard>
                      }
                    </Stack>
                  )}
                />
              </Datagrid>
            </Box>
          </List>
        </Card>
        <Dialog open={Boolean(popup)} onClose={() => setPopup(undefined)} maxWidth="md" fullWidth>
          {popup}
        </Dialog>
      </PermissionGuard>
    </DashboardContent>
  );
};

export default AgentInfoList;
